import { ReactComponent } from "./pen-line.svg";

interface Props {
  background?: string;
  width?: string;
  height?: string;
  fill?: string;
  margin?: string;
  className?: string;
}

const PenLineIcon: React.FC<Props> = ({ ...rest }) => (
  <ReactComponent {...rest} />
);

export default PenLineIcon;
